/**
 * TreeViewEditor — PropertyEditor registration for the 'tree-view' control type.
 *
 * This file is the registry entry point.
 * All UI logic lives in ../TreeViewPropertyEditor.tsx (TreeViewPropertyEditor component).
 *
 * SRP: this file's only job is to bridge the PropertyEditorProps interface
 * (used by PropertyEditorRegistry) to the standalone TreeViewPropertyEditor component.
 */

import React from 'react';
import type { PropertyEditor, PropertyEditorProps } from '../../../registry/PropertyEditor.types';
import { TreeViewPropertyEditor } from '../TreeViewPropertyEditor';

/**
 * Derive isDark from the document root class.
 * Keeps TreeViewPropertyEditor free of store dependencies so it can be used
 * outside the designer (e.g. in tests or standalone panels).
 */
function getIsDark(): boolean {
  return (
    typeof document !== 'undefined' &&
    document.documentElement.classList.contains('dark')
  );
}

function renderTreeViewEditor(props: PropertyEditorProps): React.ReactNode {
  const { control, onControlChange } = props;

  return (
    <TreeViewPropertyEditor
      control={control}
      onUpdateControl={(patch) => onControlChange(patch)}
      isDark={getIsDark()}
    />
  );
}

export const TreeViewEditor: PropertyEditor = {
  type: 'tree-view',
  label: 'Tree View',
  description:
    'Configure tree data source, field mapping, appearance, interaction, node actions, and dynamic links',
  version: '1.0.0',
  render: renderTreeViewEditor,
};

export default TreeViewEditor;
